import ApiConstants from "../../../constants/ApiConstants";
import http from "../../../http";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";

class USComplianceService {
    static FORM = null;

    static createLinkToken(payload) {
        return http.post(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.PLAID.CREATE_LINK_TOKEN, payload)
        .catch((error: any) => {
            console.error('Error while creating link token: ', error);
            return Promise.reject(error);
        });
    }

    static setAccessToken(payload) {
        return http.post(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.PLAID.SET_ACCESS_TOKEN, payload)
        .catch((error: any) => {
            console.error('Error while set access token: ', error);
            return Promise.reject(error);
        });
    }

    static verifyAccount(payload) {
        return http.post(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.PLAID.VERIFY_ACCOUNTS, payload)
        .catch((error: any) => {
            console.error('Error while verifying accounts: ', error);
            return Promise.reject(error);
        });
    }

    static getFormData() {
        const url = TenantService.get(TENANT.IS_ADMIN)
        ? ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.GET_FORM_DATA
        : ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.GET_FORM_DATA_EMPLOYEE;
        return http.get(url)
        .catch((error: any) => {
            console.error('Error while getting form data: ', error);
            return Promise.reject(error);
        });
    }

    static getForm(formId, payload) {
        return http.post(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.GET_FORM, payload, { responseType: "blob" })
        .catch((error: any) => {
            console.error('Error while get form: ', error);
            return Promise.reject(error);
        });
    }

    static signForm(formId, payload) {
        return http.post(ApiConstants.URL.BASE + ApiConstants.URL.COMPLIANCE.US.SIGN_FORM + formId, payload)
        .catch((error: any) => {
            console.error('Error while sign form: ', error);
            return Promise.reject(error);
        });
    }
}

export default USComplianceService;
